import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
    // routes: [{
    //         path: '/',
    //         name: '首页',
    //         component: index
    //     },
    //     {
    //         path: '/signin',
    //         name: '登录',
    //         component: signin
    //     },
    //     {
    //         path: '/register',
    //         name: 'register',
    //         component: register
    //     },
    //     {
    //         path: '/error',
    //         name: 'error',
    //         component: error
    //     },
    //     {
    //         path: '/retrievepass',
    //         name: 'retrievepass',
    //         component: retrievepass
    //     },
    //     {
    //         path: '/agreement',
    //         name: 'agreement',
    //         component: agreement
    //     },
    //     {
    //         path: '/leasedland_details',
    //         name: 'leasedland_details',
    //         component: leasedland_details
    //     },
    //     {
    //         path: '/orders',
    //         name: 'orders',
    //         component: orders
    //     },
    //     {
    //         path: '/shoppingcart',
    //         name: 'shoppingcart',
    //         component: shoppingcart
    //     },
    //     {
    //         path: '/confirmationorder',
    //         name: 'confirmationorder',
    //         component: confirmationorder
    //     },
    //     {
    //         path: '/listboughtitems',
    //         name: 'listboughtitems',
    //         component: listboughtitems
    //     },
    //     {
    //         path: '/orderdetail',
    //         name: 'orderdetail',
    //         component: orderdetail
    //     },
    //     {
    //         path: '/trace_detail',
    //         name: 'trace_detail',
    //         component: trace_detail
    //     },
    //     {
    //         path: '/evaluate',
    //         name: 'evaluate',
    //         component: evaluate
    //     },
    //     {
    //         path: '/apply_refund',
    //         name: 'apply_refund',
    //         component: apply_refund
    //     },
    //     {
    //         path: '/serch_list',
    //         name: 'serch_list',
    //         component: serch_list
    //     },
    //     {
    //         path: '/leasedland',
    //         name: 'leasedland',
    //         component: leasedland
    //     },
    //     {
    //         path: '/landconfirm',
    //         name: 'landconfirm',
    //         component: landconfirm
    //     },
    //     {
    //         path: '/my_land',
    //         name: 'my_land',
    //         component: my_land
    //     },
    //     {
    //         path: '/details_tenat',
    //         name: 'details_tenat',
    //         component: details_tenat
    //     },
    //     {
    //         path: '/adopt_index',
    //         name: 'adopt_index',
    //         component: adopt_index
    //     },
    //     {
    //         path: '/personal',
    //         name: 'personal',
    //         component: personal
    //     },
    //     {
    //         path: '/deliver_address',
    //         name: 'deliver_address',
    //         component: deliver_address
    //     }, {
    //         path: '/coupon',
    //         name: 'coupon',
    //         component: coupon
    //     },
    //     {
    //         path: '/my_coupon',
    //         name: 'my_coupon',
    //         component: my_coupon
    //     },
    //     {
    //         path: '/adopt_details',
    //         name: 'adopt_details',
    //         component: adopt_details
    //     },
    //     {
    //         path: '/payorder',
    //         name: 'payorder',
    //         component: payorder
    //     },
    //     {
    //         path: '/adopt_order',
    //         name: 'adopt_order',
    //         component: adopt_order
    //     },
    //     {
    //         path: '/order_details',
    //         name: 'order_details',
    //         component: order_details
    //     },
    //     {
    //         path: '/my_collect',
    //         name: 'my_collect',
    //         component: my_collect
    //     },
    //     {
    //         path: '/news_index',
    //         name: 'news_index',
    //         component: news_index
    //     },
    //     {
    //         path: '/information_details',
    //         name: 'information_details',
    //         component: information_details
    //     },
    //     {
    //         path: '/apply',
    //         name: 'apply',
    //         component: apply
    //     }, {
    //         path: '/list',
    //         name: 'list',
    //         component: list
    //     }, {
    //         path: '/storedetails',
    //         name: 'storedetails',
    //         component: storedetails
    //     }, {
    //         path: '/help',
    //         name: 'help',
    //         component: help
    //     },  {
    //         path: '/applydistribution',
    //         name: 'applydistribution',
    //         component: applydistribution
    //     }, {
    //         path: '/distributionindex',
    //         name: 'distributionindex',
    //         component: distributionindex
    //     }
    // ],
    routes: [
        {path: '/',redirect: '/index',name: '首页',component: () => import('@/page/index')},
        {path: '/index',name: '首页',component: () => import('@/page/index')},
        {path: '/signin',name: '登录',component: () => import('@/page/Signin')},
        {path: '/register',name: '注册',component: () => import('@/page/Register')},
        {path: '/retrievepass',name: '忘记密码',component: () => import('@/page/retrieve_password')},
        {path: '/agreement',name: '协议',component: () => import('@/page/agreement.vue')},
        {path: '/error',name: '页面不存在',component: () => import('@/page/error.vue')},
        {path: '/none',name: '自定义',component: () => import('@/page/none.vue')},
        {path:'*',redirect: '/error'},
        {path: '/leasedland_details',name: '租地',component: () => import('@/leasedland/leasedland_details.vue')},
        {path: '/my_land',name: '种植订单',component: () => import('@/leasedland/my_land.vue')},
        {path: '/details_tenant.vue',name: '订单详情',component: () => import('@/leasedland/details_tenant.vue')},
        {path: '/leasedland',name: '种植详情',component: () => import('@/leasedland/leasedland.vue')},
        {path: '/landconfirm',name: '种植支付',component: () => import('@/leasedland/landconfirm.vue')},
        {path: '/orderdetail',name: '商品详情',component: () => import('@/shop/order_details.vue')},
        {path: '/shoppingcart',name: '购物车',component: () => import('@/shop/shopping_cart.vue')},
        {path: '/confirmationorder',name: '商品支付',component: () => import('@/shop/confirmation_order.vue')},
        {path: '/listboughtitems',name: '商城订单',component: () => import('@/shop/list_bought_items.vue')},
        {path: '/orders',name: '订单详情',component: () => import('@/shop/orders.vue')},
        {path: '/trace_detail',name: '订单物流',component: () => import('@/shop/trace_detail.vue')},
        {path: '/evaluate',name: '评价',component: () => import('@/shop/evaluate.vue')},
        {path: '/apply_refund',name: '申请退款',component: () => import('@/shop/apply_refund.vue')},
        {path: '/serch_list',name: '搜索',component: () => import('@/shop/serch_list.vue')},
        {path: '/adopt_index',name: '领养',component: () => import('@/adopt/adopt_index.vue')},
        {path: '/adopt_details',name: '领养详情',component: () => import('@/adopt/adopt_details.vue')},
        {path: '/payorder',name: '支付',component: () => import('@/adopt/payorder.vue')},
        {path: '/adopt_order',name: '领养订单',component: () => import('@/adopt/adopt_order.vue')},
        {path: '/order_details',name: '订单详情',component: () => import('@/adopt/order_details.vue')},
        {path: '/personal',name: '个人中心',component: () => import('@/Personal/my.vue')},
        {path: '/deliver_address',name: '收货地址',component: () => import('@/Personal/deliver_address.vue')},
        {path: '/my_coupon',name: '我的优惠券',component: () => import('@/Personal/my_coupon.vue')},
        {path: '/coupon',name: '领券中心',component: () => import('@/Personal/coupon.vue')},
        {path: '/my_collect',name: '商品收藏',component: () => import('@/Personal/my_collect.vue')},
        {path: '/help',name: '帮助中心',component: () => import('@/page/help.vue')},
        {path: '/news_index',name: '新闻资讯',component: () => import('@/news_information/index.vue')},
        {path: '/information_details',name: '详情',component: () => import('@/news_information/information_details.vue')},
        {path: '/apply',name: '入驻申请',component: () => import('@/store/apply.vue')},
        {path: '/list',name: '商户列表',component: () => import('@/store/index.vue')},
        {path: '/storedetails',name: '商户详情',component: () => import('@/store/store_detail.vue')},
        {path: '/applydistribution',name: '分销商',component: () => import('@/distribution/apply.vue')},
        {path: '/distributionindex',name: '分销商',component: () => import('@/distribution/index.vue')}
    ],
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js